import personPortraits from "./personPortraits.json";

interface PortraitSource {
  width: number;
  height: number;
  variants: { src: string; width: number }[];
}

const sources: Record<string, PortraitSource> = personPortraits;

export const getPersonPortraitImageProps = (
  imageUrl: string,
  width: number,
  height = width,
) => {
  const portrait = sources[imageUrl];
  if (!portrait) return { src: imageUrl };

  // Object-fit: cover can render a landscape photo wider than the avatar box.
  const renderedWidth = Math.ceil(
    Math.max(width, (height * portrait.width) / portrait.height),
  );
  const fallback =
    portrait.variants.find((variant) => variant.width >= 128) ??
    portrait.variants[portrait.variants.length - 1];
  return {
    src: fallback.src,
    srcSet: portrait.variants
      .map((variant) => `${variant.src} ${variant.width}w`)
      .join(", "),
    sizes: `${renderedWidth}px`,
  };
};
